// Lead-Spalte einer Inbox-Zeile: Lead-Name (Link) und Kontakt, rechts die Status-Pille. Ohne Lead (Anruf von einer
// unbekannten Nummer) steht dort die Nummer und die Pille „Kein Lead“; ein Klick öffnet die Nummern-Suche.
import type { Aufgabe } from "../../api";
import { useMeta } from "../../daten/meta";
import { StatusPille } from "../Bausteine";
import { hatNummer, nummerText } from "./typen";
import "./inbox.css";

export function LeadZelle({ aufgabe: a, onOeffnen }: { aufgabe: Aufgabe; onOeffnen?: () => void }) {
  const meta = useMeta();
  if (!a.lead_id) {
    return (
      <div className="aufgabe__lead">
        <span className="aufgabe__leadzelle">
          {hatNummer(a) ? (
            <button type="button" className="aufgabe__nummer" title="Nummer in den Leads suchen" onClick={() => onOeffnen?.()}>
              {nummerText(a)}
            </button>
          ) : (
            <span className="aufgabe__nummer aufgabe__nummer--leise">{a.lead_name ?? "Kein Lead"}</span>
          )}
        </span>
        <span className="status-pille status-pille--klein kein-lead-pille">Kein Lead</span>
      </div>
    );
  }
  return (
    <div className="aufgabe__lead">
      <span className="aufgabe__leadzelle">
        <a
          href={`/lead/${encodeURIComponent(a.lead_id)}`}
          className="aufgabe__leadname"
          onClick={(e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey) return;
            e.preventDefault();
            onOeffnen?.();
          }}
        >
          {a.lead_name ?? "Lead"}
        </a>
        {a.contact_name && a.contact_name !== a.lead_name ? <span className="aufgabe__kontakt">, {a.contact_name}</span> : null}
      </span>
      <StatusPille label={a.lead_status_label} farbe={meta.meta?.lead_statuses.find((s) => s.label === a.lead_status_label)?.color} klein schlicht />
    </div>
  );
}
